import { Currency } from '@uniswap/sdk-core'
import Column, { AutoColumn } from 'components/Column'
import { Trans } from 'i18n'
import styled from 'styled-components'

import { Field } from './constants'
import { SwapModalHeaderAmount } from './SwapModalHeaderAmount'
import { SwapModalHeaderAmount as WrapModalHeaderAmount} from './WrapModalHeaderAmount'


const HeaderContainer = styled(AutoColumn)`
  margin-top: 0px;
`

export function SwapPreview({
  nutsAmount,
  nuts404Amount,
  nutsIds,
  inputCurrency,
  isWrap = false,
}: {
  nutsAmount?: string
  nuts404Amount: string
  nutsIds: string
  inputCurrency?: Currency
  isWrap?: boolean
}) {
 

  return (
    <HeaderContainer gap="sm">
      
      {!isWrap && (
        <Column gap="lg">
          <SwapModalHeaderAmount
            field={Field.INPUT}
            label={<Trans>Burn</Trans>}
            nutsAmount={nutsAmount}
            currency={inputCurrency}
            isLoading={false}
          />
          <SwapModalHeaderAmount
            field={Field.OUTPUT}
            label={<Trans>Mint</Trans>}
            nutsAmount={nutsAmount}
            currency={undefined}
            isLoading={false}
          />
        </Column>
      )}

      {isWrap && (
        <Column gap="lg">
          <WrapModalHeaderAmount
            field={Field.INPUT}
            label={inputCurrency?.symbol == "NUTS" ? <Trans>Lock id(s)</Trans> : <Trans>Lock</Trans> }
            nuts404Amount={nuts404Amount}
            nutsIds={nutsIds}
            currencySymbol={inputCurrency?.symbol}
            isLoading={false}
          />
          <WrapModalHeaderAmount
            field={Field.OUTPUT}
            label={<Trans>Unlock</Trans>}
            nuts404Amount={nuts404Amount}
            nutsIds={nutsIds}
            currencySymbol={inputCurrency?.symbol == "NUTS404" ? "NUTS" : "NUTS404" }
            isLoading={false}
          />
        </Column>
      )}
        
    </HeaderContainer>
  )
}
